import React from "react";
import { Modal, ModalBody } from "reactstrap";
class CustomisedModal extends React.Component {
  render() {
    return (
      <Modal
        className={this.props.modalClass || "modal-lg"}
        isOpen={this.props.isModalOpen}
        backdrop="static"
        keyboard={false}
        toggle={this.props.onToggle}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">{this.props.modalTitle}</h5>
          <button
            onClick={this.props.onModalDismiss}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>{this.props.children}</ModalBody>
      </Modal>
    );
  }
}

export default CustomisedModal;
